var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSomethingWentWrong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 80,
    fill: "none",
    viewBox: "0 0 130 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#something-went-wrong_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#something-went-wrong_svg__b)",
    fillRule: "evenodd",
    d: "M26.416 15.452q1.99-6.288 3.7-7.83c3.157-2.849 7.522-1.299 8.45-1.077 3.26.782 2.2-4.364 4.997-5.41q2.796-1.045 4.6 2.556Q49.76.332 53.033.608c3.271.277 4.416 11.328 8.912 8.91 4.497-2.42 10.01-2.974 12.365.622.51.778.704-.429 4.166-4.55 3.462-4.122 6.914-5.938 13.996-3.538q4.83 1.635 7.947 8.864 0 10.318 15.178 12.213c15.179 1.895 3.397 18.214-15.178 22.993-18.576 4.78-61.343 7.36-84.55-4.716Q-7.34 29.333 26.414 15.452z",
    clipRule: "evenodd",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#something-went-wrong_svg__c)",
    d: "M64.477 76.232c15.456 0 27.986-2.9 27.986-6.478s-12.53-6.478-27.986-6.478-27.988 2.9-27.988 6.478 12.53 6.478 27.988 6.478"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#something-went-wrong_svg__d)",
    fillRule: "evenodd",
    d: "M111.727 77.837c-21.044 5.278-92.87-.759-100.515-3.516Q5.63 72.307 1.15 66.745a2.822 2.822 0 0 1 2.198-4.593h125.514q3.908 10.407-17.136 15.685",
    clipRule: "evenodd",
    opacity: 0.675
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    x: 41,
    y: 14.259,
    fill: "#FFE4E4",
    rx: 24
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#something-went-wrong_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EF5353",
    d: "M63.715 43.83a1.286 1.286 0 1 0 2.571 0 1.286 1.286 0 0 0-2.571 0m.428-8.142v4.928c0 .118.097.215.215.215h1.285a.215.215 0 0 0 .215-.215v-4.928a.215.215 0 0 0-.215-.214h-1.285a.215.215 0 0 0-.215.214m12.742 11.786L65.744 28.188a.85.85 0 0 0-.742-.429.84.84 0 0 0-.742.429L53.116 47.474a.857.857 0 0 0 .742 1.285h22.286a.857.857 0 0 0 .741-1.285M55.9 46.726 65 30.971l9.102 15.755z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "something-went-wrong_svg__b",
    x1: 67.207,
    x2: 67.207,
    y1: 37.538,
    y2: -8.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEDE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9A9",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "something-went-wrong_svg__c",
    x1: 61.56,
    x2: 61.56,
    y1: 76.232,
    y2: 63.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF5353",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "something-went-wrong_svg__d",
    x1: 65,
    x2: 65,
    y1: 79.931,
    y2: 58.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#919191",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "something-went-wrong_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.526.588h128.949V79.93H.525z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "something-went-wrong_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M53 26.26h24v24H53z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSomethingWentWrong);
export default __webpack_public_path__ + "static/media/something-went-wrong.cd499d0492b888fe9fd48cebb2ea8f43.svg";
export { ForwardRef as ReactComponent };